var map = {
	"./1.png": 9227,
	"./2.png": 7248,
	"./3.png": 5369,
	"./4.png": 5286,
	"./defaut.png": 8093,
	"./sac-ferme.png": 3299,
	"./sac-ouvert.png": 2313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3634;